const translations = {
  en: {
    // Header
    appTitle: "Cut & Recompose PDF",
    tabSelectAreas: "Select Areas",
    tabCompose: "Compose New PDF",

    // PDF Viewer
    selectedAreas: "Selected areas",
    extracting: "🔄 Extracting high-resolution PDF content...",
    clickDragSelect: "✂️ Click and drag to select areas",
    navigateMode: "👆 Navigate mode: scroll and interact with PDF",
    goToCompose: "🧩 Go to Compose New PDF when you have selected all needed areas",

    // PDF Controls
    selectionMode: "✂️ Selection",
    navigateButton: "👆 Navigate",

    // Area item
    area: "Area",
    page: "Page",

    // PDF Upload
    pdfSource: "PDF Source:",
    localFile: "Local File",
    onlineUrl: "Online URL",
    uploadPdfFile: "Upload PDF File:",
    enterPdfUrl: "Enter PDF URL:",
    pasteUrlHere: "Paste PDF URL here...",
    selectPdfUrl: "Select PDF URL:",
    selectPdf: "-- Select a PDF --",
    originalPattern: "Original Knitting Pattern",
    viaCorsProxy: "Via CORS Proxy",
    testPdf: "Test PDF (Mozilla)",

    // PDF Error
    couldNotLoad: "Could not load PDF directly. Try opening the PDF in a new tab first, then come back to select areas:",
    openInNewTab: "Open PDF in new tab",
    canStillUse: "You can still use the selection tool below on any loaded content.",
    loadingPdf: "🔄 Loading PDF...",
    uploadToStart: "📄 Please upload a PDF file to get started",

    // Workspace
    dragAreasHere: "Drag selected areas here to arrange your composition",
    dragCornerToResize: "Drag the blue corner handle to resize areas",
    availablePdfAreas: "Available PDF Areas",
    noAreasYet: "No areas selected yet. Go to the \"Select Areas\" tab to create PDF areas.",
    dropAreasHere: "Drop PDF areas here",
    magnetSnap: "Magnet Snap",
    clearAll: "Clear All",
    exportImage: "Export Image",

    // Crop Editor
    cropPiece: "Crop Piece",
    dragLinesToCrop: "Drag the red lines to define the crop area",
    cropAreaTooSmall: "Crop area too small",
    cropError: "Error cropping image",
    saveCrop: "Save Crop",
    cancel: "Cancel"
  },

  de: {
    // Header
    appTitle: "PDF Ausschneiden & Neu Zusammenstellen",
    tabSelectAreas: "Bereiche Auswählen",
    tabCompose: "Neues PDF Erstellen",

    // PDF Viewer
    selectedAreas: "Ausgewählte Bereiche",
    extracting: "🔄 Extrahiere hochauflösenden PDF-Inhalt...",
    clickDragSelect: "✂️ Klicken und ziehen Sie, um Bereiche auszuwählen",
    navigateMode: "👆 Navigationsmodus: Scrollen und mit PDF interagieren",
    goToCompose: "🧩 Gehen Sie zu Neues PDF Erstellen, wenn Sie alle benötigten Bereiche ausgewählt haben",

    // PDF Controls
    selectionMode: "✂️ Auswahl",
    navigateButton: "👆 Navigation",

    // Area item
    area: "Bereich",
    page: "Seite",

    // PDF Upload
    pdfSource: "PDF-Quelle:",
    localFile: "Lokale Datei",
    onlineUrl: "Online-URL",
    uploadPdfFile: "PDF-Datei hochladen:",
    enterPdfUrl: "PDF-URL eingeben:",
    pasteUrlHere: "PDF-URL hier einfügen...",
    selectPdfUrl: "PDF-URL auswählen:",
    selectPdf: "-- PDF auswählen --",
    originalPattern: "Original-Strickmuster",
    viaCorsProxy: "Über CORS-Proxy",
    testPdf: "Test-PDF (Mozilla)",

    // PDF Error
    couldNotLoad: "PDF konnte nicht direkt geladen werden. Versuchen Sie, das PDF zuerst in einem neuen Tab zu öffnen, und kommen Sie dann zurück, um Bereiche auszuwählen:",
    openInNewTab: "PDF in neuem Tab öffnen",
    canStillUse: "Sie können das Auswahlwerkzeug weiterhin für geladene Inhalte verwenden.",
    loadingPdf: "🔄 PDF wird geladen...",
    uploadToStart: "📄 Bitte laden Sie eine PDF-Datei hoch, um zu beginnen",

    // Workspace
    dragAreasHere: "Ziehen Sie ausgewählte Bereiche hierher, um Ihre Komposition anzuordnen",
    dragCornerToResize: "Ziehen Sie den blauen Eckgriff, um Bereiche zu skalieren",
    availablePdfAreas: "Verfügbare PDF-Bereiche",
    noAreasYet: "Noch keine Bereiche ausgewählt. Gehen Sie zur Registerkarte \"Bereiche Auswählen\", um PDF-Bereiche zu erstellen.",
    dropAreasHere: "PDF-Bereiche hier ablegen",
    magnetSnap: "Magnetisches Einrasten",
    clearAll: "Alle Löschen",
    exportImage: "Bild Exportieren",

    // Crop Editor
    cropPiece: "Bereich Zuschneiden",
    dragLinesToCrop: "Ziehen Sie die roten Linien, um den Zuschneidebereich zu definieren",
    cropAreaTooSmall: "Zuschneidebereich zu klein",
    cropError: "Fehler beim Zuschneiden des Bildes",
    saveCrop: "Zuschnitt Speichern",
    cancel: "Abbrechen"
  },

  fr: {
    // Header
    appTitle: "Découper & Recomposer PDF",
    tabSelectAreas: "Sélectionner les Zones",
    tabCompose: "Composer un Nouveau PDF",

    // PDF Viewer
    selectedAreas: "Zones sélectionnées",
    extracting: "🔄 Extraction du contenu PDF haute résolution...",
    clickDragSelect: "✂️ Cliquez et faites glisser pour sélectionner des zones",
    navigateMode: "👆 Mode navigation: faites défiler et interagissez avec le PDF",
    goToCompose: "🧩 Allez dans Composer un Nouveau PDF lorsque vous avez sélectionné toutes les zones nécessaires",

    // PDF Controls
    selectionMode: "✂️ Sélection",
    navigateButton: "👆 Navigation",

    // Area item
    area: "Zone",
    page: "Page",

    // PDF Upload
    pdfSource: "Source PDF:",
    localFile: "Fichier Local",
    onlineUrl: "URL en Ligne",
    uploadPdfFile: "Télécharger un fichier PDF:",
    enterPdfUrl: "Entrer l'URL du PDF:",
    pasteUrlHere: "Coller l'URL du PDF ici...",
    selectPdfUrl: "Sélectionner l'URL du PDF:",
    selectPdf: "-- Sélectionner un PDF --",
    originalPattern: "Motif de Tricot Original",
    viaCorsProxy: "Via Proxy CORS",
    testPdf: "PDF de Test (Mozilla)",

    // PDF Error
    couldNotLoad: "Impossible de charger le PDF directement. Essayez d'ouvrir le PDF dans un nouvel onglet d'abord, puis revenez pour sélectionner les zones:",
    openInNewTab: "Ouvrir le PDF dans un nouvel onglet",
    canStillUse: "Vous pouvez toujours utiliser l'outil de sélection ci-dessous sur tout contenu chargé.",
    loadingPdf: "🔄 Chargement du PDF...",
    uploadToStart: "📄 Veuillez télécharger un fichier PDF pour commencer",

    // Workspace
    dragAreasHere: "Faites glisser les zones sélectionnées ici pour organiser votre composition",
    dragCornerToResize: "Faites glisser la poignée d'angle bleue pour redimensionner les zones",
    availablePdfAreas: "Zones PDF Disponibles",
    noAreasYet: "Aucune zone sélectionnée pour le moment. Allez dans l'onglet \"Sélectionner les Zones\" pour créer des zones PDF.",
    dropAreasHere: "Déposez les zones PDF ici",
    magnetSnap: "Aimantation",
    clearAll: "Tout Effacer",
    exportImage: "Exporter l'Image",

    // Crop Editor
    cropPiece: "Recadrer la Zone",
    dragLinesToCrop: "Faites glisser les lignes rouges pour définir la zone de recadrage",
    cropAreaTooSmall: "Zone de recadrage trop petite",
    cropError: "Erreur lors du recadrage de l'image",
    saveCrop: "Enregistrer le Recadrage",
    cancel: "Annuler"
  },

  ru: {
    // Header
    appTitle: "Вырезать и Пересоставить PDF",
    tabSelectAreas: "Выбрать Области",
    tabCompose: "Создать Новый PDF",

    // PDF Viewer
    selectedAreas: "Выбранные области",
    extracting: "🔄 Извлечение содержимого PDF в высоком разрешении...",
    clickDragSelect: "✂️ Нажмите и перетащите, чтобы выбрать области",
    navigateMode: "👆 Режим навигации: прокручивайте и взаимодействуйте с PDF",
    goToCompose: "🧩 Перейдите в Создать Новый PDF, когда выберете все необходимые области",

    // PDF Controls
    selectionMode: "✂️ Выбор",
    navigateButton: "👆 Навигация",

    // Area item
    area: "Область",
    page: "Страница",

    // PDF Upload
    pdfSource: "Источник PDF:",
    localFile: "Локальный Файл",
    onlineUrl: "Онлайн URL",
    uploadPdfFile: "Загрузить PDF файл:",
    enterPdfUrl: "Введите URL PDF:",
    pasteUrlHere: "Вставьте URL PDF здесь...",
    selectPdfUrl: "Выбрать URL PDF:",
    selectPdf: "-- Выбрать PDF --",
    originalPattern: "Оригинальный Узор для Вязания",
    viaCorsProxy: "Через CORS Прокси",
    testPdf: "Тестовый PDF (Mozilla)",

    // PDF Error
    couldNotLoad: "Не удалось загрузить PDF напрямую. Попробуйте открыть PDF в новой вкладке, затем вернитесь для выбора областей:",
    openInNewTab: "Открыть PDF в новой вкладке",
    canStillUse: "Вы все еще можете использовать инструмент выбора для загруженного содержимого.",
    loadingPdf: "🔄 Загрузка PDF...",
    uploadToStart: "📄 Пожалуйста, загрузите PDF файл для начала работы",

    // Workspace
    dragAreasHere: "Перетащите выбранные области сюда, чтобы организовать композицию",
    dragCornerToResize: "Перетащите синий угловой маркер для изменения размера областей",
    availablePdfAreas: "Доступные PDF Области",
    noAreasYet: "Пока нет выбранных областей. Перейдите на вкладку \"Выбрать Области\", чтобы создать PDF области.",
    dropAreasHere: "Поместите PDF области сюда",
    magnetSnap: "Магнитное Прилипание",
    clearAll: "Очистить Все",
    exportImage: "Экспортировать Изображение",

    // Crop Editor
    cropPiece: "Обрезать Область",
    dragLinesToCrop: "Перетащите красные линии, чтобы определить область обрезки",
    cropAreaTooSmall: "Область обрезки слишком мала",
    cropError: "Ошибка при обрезке изображения",
    saveCrop: "Сохранить Обрезку",
    cancel: "Отмена"
  },

  pl: {
    // Header
    appTitle: "Wytnij i Złóż PDF",
    tabSelectAreas: "Wybierz Obszary",
    tabCompose: "Utwórz Nowy PDF",

    // PDF Viewer
    selectedAreas: "Wybrane obszary",
    extracting: "🔄 Wyodrębnianie zawartości PDF w wysokiej rozdzielczości...",
    clickDragSelect: "✂️ Kliknij i przeciągnij, aby wybrać obszary",
    navigateMode: "👆 Tryb nawigacji: przewijaj i wchodź w interakcję z PDF",
    goToCompose: "🧩 Przejdź do Utwórz Nowy PDF, gdy wybierzesz wszystkie potrzebne obszary",

    // PDF Controls
    selectionMode: "✂️ Wybór",
    navigateButton: "👆 Nawigacja",

    // Area item
    area: "Obszar",
    page: "Strona",

    // PDF Upload
    pdfSource: "Źródło PDF:",
    localFile: "Plik Lokalny",
    onlineUrl: "URL Online",
    uploadPdfFile: "Prześlij plik PDF:",
    enterPdfUrl: "Wprowadź URL PDF:",
    pasteUrlHere: "Wklej URL PDF tutaj...",
    selectPdfUrl: "Wybierz URL PDF:",
    selectPdf: "-- Wybierz PDF --",
    originalPattern: "Oryginalny Wzór do Dziania",
    viaCorsProxy: "Przez Proxy CORS",
    testPdf: "Testowy PDF (Mozilla)",

    // PDF Error
    couldNotLoad: "Nie można było załadować PDF bezpośrednio. Spróbuj najpierw otworzyć PDF w nowej karcie, a następnie wróć, aby wybrać obszary:",
    openInNewTab: "Otwórz PDF w nowej karcie",
    canStillUse: "Nadal możesz użyć narzędzia wyboru na załadowanej zawartości.",
    loadingPdf: "🔄 Ładowanie PDF...",
    uploadToStart: "📄 Prześlij plik PDF, aby rozpocząć",

    // Workspace
    dragAreasHere: "Przeciągnij wybrane obszary tutaj, aby ułożyć kompozycję",
    dragCornerToResize: "Przeciągnij niebieski uchwyt narożny, aby zmienić rozmiar obszarów",
    availablePdfAreas: "Dostępne Obszary PDF",
    noAreasYet: "Nie wybrano jeszcze obszarów. Przejdź do zakładki \"Wybierz Obszary\", aby utworzyć obszary PDF.",
    dropAreasHere: "Upuść obszary PDF tutaj",
    magnetSnap: "Magnetyczne Przyciąganie",
    clearAll: "Wyczyść Wszystko",
    exportImage: "Eksportuj Obraz",

    // Crop Editor
    cropPiece: "Przytnij Obszar",
    dragLinesToCrop: "Przeciągnij czerwone linie, aby zdefiniować obszar przycięcia",
    cropAreaTooSmall: "Obszar przycięcia zbyt mały",
    cropError: "Błąd podczas przycinania obrazu",
    saveCrop: "Zapisz Przycięcie",
    cancel: "Anuluj"
  },

  es: {
    // Header
    appTitle: "Cortar y Recomponer PDF",
    tabSelectAreas: "Seleccionar Áreas",
    tabCompose: "Componer Nuevo PDF",

    // PDF Viewer
    selectedAreas: "Áreas seleccionadas",
    extracting: "🔄 Extrayendo contenido PDF de alta resolución...",
    clickDragSelect: "✂️ Haz clic y arrastra para seleccionar áreas",
    navigateMode: "👆 Modo navegación: desplázate e interactúa con el PDF",
    goToCompose: "🧩 Ve a Componer Nuevo PDF cuando hayas seleccionado todas las áreas necesarias",

    // PDF Controls
    selectionMode: "✂️ Selección",
    navigateButton: "👆 Navegación",

    // Area item
    area: "Área",
    page: "Página",

    // PDF Upload
    pdfSource: "Fuente PDF:",
    localFile: "Archivo Local",
    onlineUrl: "URL en Línea",
    uploadPdfFile: "Subir archivo PDF:",
    enterPdfUrl: "Introducir URL del PDF:",
    pasteUrlHere: "Pegar URL del PDF aquí...",
    selectPdfUrl: "Seleccionar URL del PDF:",
    selectPdf: "-- Seleccionar PDF --",
    originalPattern: "Patrón de Tejido Original",
    viaCorsProxy: "Vía Proxy CORS",
    testPdf: "PDF de Prueba (Mozilla)",

    // PDF Error
    couldNotLoad: "No se pudo cargar el PDF directamente. Intenta abrir el PDF en una nueva pestaña primero, luego regresa para seleccionar áreas:",
    openInNewTab: "Abrir PDF en nueva pestaña",
    canStillUse: "Aún puedes usar la herramienta de selección en cualquier contenido cargado.",
    loadingPdf: "🔄 Cargando PDF...",
    uploadToStart: "📄 Por favor, sube un archivo PDF para comenzar",

    // Workspace
    dragAreasHere: "Arrastra las áreas seleccionadas aquí para organizar tu composición",
    dragCornerToResize: "Arrastra el control de esquina azul para cambiar el tamaño de las áreas",
    availablePdfAreas: "Áreas PDF Disponibles",
    noAreasYet: "Aún no hay áreas seleccionadas. Ve a la pestaña \"Seleccionar Áreas\" para crear áreas PDF.",
    dropAreasHere: "Suelta las áreas PDF aquí",
    magnetSnap: "Alineación Magnética",
    clearAll: "Limpiar Todo",
    exportImage: "Exportar Imagen",

    // Crop Editor
    cropPiece: "Recortar Área",
    dragLinesToCrop: "Arrastra las líneas rojas para definir el área de recorte",
    cropAreaTooSmall: "Área de recorte demasiado pequeña",
    cropError: "Error al recortar la imagen",
    saveCrop: "Guardar Recorte",
    cancel: "Cancelar"
  },

  it: {
    // Header
    appTitle: "Taglia e Ricomponi PDF",
    tabSelectAreas: "Seleziona Aree",
    tabCompose: "Componi Nuovo PDF",

    // PDF Viewer
    selectedAreas: "Aree selezionate",
    extracting: "🔄 Estrazione del contenuto PDF ad alta risoluzione...",
    clickDragSelect: "✂️ Clicca e trascina per selezionare le aree",
    navigateMode: "👆 Modalità navigazione: scorri e interagisci con il PDF",
    goToCompose: "🧩 Vai a Componi Nuovo PDF quando hai selezionato tutte le aree necessarie",

    // PDF Controls
    selectionMode: "✂️ Selezione",
    navigateButton: "👆 Navigazione",

    // Area item
    area: "Area",
    page: "Pagina",

    // PDF Upload
    pdfSource: "Fonte PDF:",
    localFile: "File Locale",
    onlineUrl: "URL Online",
    uploadPdfFile: "Carica file PDF:",
    enterPdfUrl: "Inserisci URL PDF:",
    pasteUrlHere: "Incolla URL PDF qui...",
    selectPdfUrl: "Seleziona URL PDF:",
    selectPdf: "-- Seleziona PDF --",
    originalPattern: "Schema Originale a Maglia",
    viaCorsProxy: "Tramite Proxy CORS",
    testPdf: "PDF di Test (Mozilla)",

    // PDF Error
    couldNotLoad: "Impossibile caricare il PDF direttamente. Prova ad aprire il PDF in una nuova scheda prima, poi torna per selezionare le aree:",
    openInNewTab: "Apri PDF in nuova scheda",
    canStillUse: "Puoi ancora usare lo strumento di selezione su qualsiasi contenuto caricato.",
    loadingPdf: "🔄 Caricamento PDF...",
    uploadToStart: "📄 Carica un file PDF per iniziare",

    // Workspace
    dragAreasHere: "Trascina le aree selezionate qui per organizzare la tua composizione",
    dragCornerToResize: "Trascina la maniglia d'angolo blu per ridimensionare le aree",
    availablePdfAreas: "Aree PDF Disponibili",
    noAreasYet: "Nessuna area selezionata ancora. Vai alla scheda \"Seleziona Aree\" per creare aree PDF.",
    dropAreasHere: "Rilascia le aree PDF qui",
    magnetSnap: "Snap Magnetico",
    clearAll: "Cancella Tutto",
    exportImage: "Esporta Immagine",

    // Crop Editor
    cropPiece: "Ritaglia Area",
    dragLinesToCrop: "Trascina le linee rosse per definire l'area di ritaglio",
    cropAreaTooSmall: "Area di ritaglio troppo piccola",
    cropError: "Errore durante il ritaglio dell'immagine",
    saveCrop: "Salva Ritaglio",
    cancel: "Annulla"
  },

  ko: {
    // Header
    appTitle: "PDF 자르기 및 재구성",
    tabSelectAreas: "영역 선택",
    tabCompose: "새 PDF 작성",

    // PDF Viewer
    selectedAreas: "선택된 영역",
    extracting: "🔄 고해상도 PDF 콘텐츠 추출 중...",
    clickDragSelect: "✂️ 클릭하고 드래그하여 영역 선택",
    navigateMode: "👆 탐색 모드: PDF 스크롤 및 상호작용",
    goToCompose: "🧩 필요한 모든 영역을 선택했으면 새 PDF 작성으로 이동하세요",

    // PDF Controls
    selectionMode: "✂️ 선택",
    navigateButton: "👆 탐색",

    // Area item
    area: "영역",
    page: "페이지",

    // PDF Upload
    pdfSource: "PDF 소스:",
    localFile: "로컬 파일",
    onlineUrl: "온라인 URL",
    uploadPdfFile: "PDF 파일 업로드:",
    enterPdfUrl: "PDF URL 입력:",
    pasteUrlHere: "여기에 PDF URL을 붙여넣으세요...",
    selectPdfUrl: "PDF URL 선택:",
    selectPdf: "-- PDF 선택 --",
    originalPattern: "원본 뜨개질 패턴",
    viaCorsProxy: "CORS 프록시 경유",
    testPdf: "테스트 PDF (Mozilla)",

    // PDF Error
    couldNotLoad: "PDF를 직접 로드할 수 없습니다. 먼저 새 탭에서 PDF를 연 다음 영역을 선택하려면 돌아오세요:",
    openInNewTab: "새 탭에서 PDF 열기",
    canStillUse: "로드된 콘텐츠에서 여전히 선택 도구를 사용할 수 있습니다.",
    loadingPdf: "🔄 PDF 로딩 중...",
    uploadToStart: "📄 시작하려면 PDF 파일을 업로드하세요",

    // Workspace
    dragAreasHere: "선택한 영역을 여기로 드래그하여 구성을 정리하세요",
    dragCornerToResize: "파란색 모서리 핸들을 드래그하여 영역 크기 조정",
    availablePdfAreas: "사용 가능한 PDF 영역",
    noAreasYet: "아직 선택된 영역이 없습니다. \"영역 선택\" 탭으로 이동하여 PDF 영역을 만드세요.",
    dropAreasHere: "여기에 PDF 영역 놓기",
    magnetSnap: "자석 스냅",
    clearAll: "모두 지우기",
    exportImage: "이미지 내보내기",

    // Crop Editor
    cropPiece: "영역 자르기",
    dragLinesToCrop: "빨간 선을 드래그하여 자를 영역을 정의하세요",
    cropAreaTooSmall: "자를 영역이 너무 작습니다",
    cropError: "이미지 자르기 오류",
    saveCrop: "자르기 저장",
    cancel: "취소"
  },

  da: {
    // Header
    appTitle: "Klip og Sammensæt PDF",
    tabSelectAreas: "Vælg Områder",
    tabCompose: "Opret Ny PDF",

    // PDF Viewer
    selectedAreas: "Valgte områder",
    extracting: "🔄 Udtrækker PDF-indhold i høj opløsning...",
    clickDragSelect: "✂️ Klik og træk for at vælge områder",
    navigateMode: "👆 Navigationstilstand: rul og interager med PDF",
    goToCompose: "🧩 Gå til Opret Ny PDF, når du har valgt alle nødvendige områder",

    // PDF Controls
    selectionMode: "✂️ Valg",
    navigateButton: "👆 Navigation",

    // Area item
    area: "Område",
    page: "Side",

    // PDF Upload
    pdfSource: "PDF-kilde:",
    localFile: "Lokal Fil",
    onlineUrl: "Online URL",
    uploadPdfFile: "Upload PDF-fil:",
    enterPdfUrl: "Indtast PDF URL:",
    pasteUrlHere: "Indsæt PDF URL her...",
    selectPdfUrl: "Vælg PDF URL:",
    selectPdf: "-- Vælg PDF --",
    originalPattern: "Original Strikmønster",
    viaCorsProxy: "Via CORS Proxy",
    testPdf: "Test PDF (Mozilla)",

    // PDF Error
    couldNotLoad: "Kunne ikke indlæse PDF direkte. Prøv at åbne PDF'en i en ny fane først, og vend derefter tilbage for at vælge områder:",
    openInNewTab: "Åbn PDF i ny fane",
    canStillUse: "Du kan stadig bruge udvælgelsesværktøjet på indlæst indhold.",
    loadingPdf: "🔄 Indlæser PDF...",
    uploadToStart: "📄 Upload venligst en PDF-fil for at komme i gang",

    // Workspace
    dragAreasHere: "Træk valgte områder hertil for at arrangere din sammensætning",
    dragCornerToResize: "Træk det blå hjørnehåndtag for at ændre størrelse på områder",
    availablePdfAreas: "Tilgængelige PDF-områder",
    noAreasYet: "Ingen områder valgt endnu. Gå til fanen \"Vælg Områder\" for at oprette PDF-områder.",
    dropAreasHere: "Slip PDF-områder her",
    magnetSnap: "Magnetisk Tilpasning",
    clearAll: "Ryd Alt",
    exportImage: "Eksporter Billede",

    // Crop Editor
    cropPiece: "Beskær Område",
    dragLinesToCrop: "Træk de røde linjer for at definere beskæringsområdet",
    cropAreaTooSmall: "Beskæringsområde for lille",
    cropError: "Fejl ved beskæring af billede",
    saveCrop: "Gem Beskæring",
    cancel: "Annuller"
  },

  sv: {
    // Header
    appTitle: "Klipp och Omkomponera PDF",
    tabSelectAreas: "Välj Områden",
    tabCompose: "Skapa Ny PDF",

    // PDF Viewer
    selectedAreas: "Valda områden",
    extracting: "🔄 Extraherar PDF-innehåll i hög upplösning...",
    clickDragSelect: "✂️ Klicka och dra för att välja områden",
    navigateMode: "👆 Navigeringsläge: scrolla och interagera med PDF",
    goToCompose: "🧩 Gå till Skapa Ny PDF när du har valt alla nödvändiga områden",

    // PDF Controls
    selectionMode: "✂️ Urval",
    navigateButton: "👆 Navigering",

    // Area item
    area: "Område",
    page: "Sida",

    // PDF Upload
    pdfSource: "PDF-källa:",
    localFile: "Lokal Fil",
    onlineUrl: "Online URL",
    uploadPdfFile: "Ladda upp PDF-fil:",
    enterPdfUrl: "Ange PDF URL:",
    pasteUrlHere: "Klistra in PDF URL här...",
    selectPdfUrl: "Välj PDF URL:",
    selectPdf: "-- Välj PDF --",
    originalPattern: "Originalstrickmönster",
    viaCorsProxy: "Via CORS Proxy",
    testPdf: "Test PDF (Mozilla)",

    // PDF Error
    couldNotLoad: "Kunde inte ladda PDF direkt. Försök öppna PDF:en i en ny flik först och återvänd sedan för att välja områden:",
    openInNewTab: "Öppna PDF i ny flik",
    canStillUse: "Du kan fortfarande använda urvalsverktyget på laddat innehåll.",
    loadingPdf: "🔄 Laddar PDF...",
    uploadToStart: "📄 Vänligen ladda upp en PDF-fil för att komma igång",

    // Workspace
    dragAreasHere: "Dra valda områden hit för att arrangera din komposition",
    dragCornerToResize: "Dra det blå hörnhandtaget för att ändra storlek på områden",
    availablePdfAreas: "Tillgängliga PDF-områden",
    noAreasYet: "Inga områden valda än. Gå till fliken \"Välj Områden\" för att skapa PDF-områden.",
    dropAreasHere: "Släpp PDF-områden här",
    magnetSnap: "Magnetisk Snäppning",
    clearAll: "Rensa Allt",
    exportImage: "Exportera Bild",

    // Crop Editor
    cropPiece: "Beskär Område",
    dragLinesToCrop: "Dra de röda linjerna för att definiera beskärningsområdet",
    cropAreaTooSmall: "Beskärningsområde för litet",
    cropError: "Fel vid beskärning av bild",
    saveCrop: "Spara Beskärning",
    cancel: "Avbryt"
  },

  fi: {
    // Header
    appTitle: "Leikkaa ja Järjestä PDF Uudelleen",
    tabSelectAreas: "Valitse Alueet",
    tabCompose: "Luo Uusi PDF",

    // PDF Viewer
    selectedAreas: "Valitut alueet",
    extracting: "🔄 Puretaan PDF-sisältöä korkealla resoluutiolla...",
    clickDragSelect: "✂️ Napsauta ja vedä valitaksesi alueita",
    navigateMode: "👆 Navigointitila: vieritä ja ole vuorovaikutuksessa PDF:n kanssa",
    goToCompose: "🧩 Siirry Luo Uusi PDF kun olet valinnut kaikki tarvittavat alueet",

    // PDF Controls
    selectionMode: "✂️ Valinta",
    navigateButton: "👆 Navigointi",

    // Area item
    area: "Alue",
    page: "Sivu",

    // PDF Upload
    pdfSource: "PDF-lähde:",
    localFile: "Paikallinen Tiedosto",
    onlineUrl: "Verkko-URL",
    uploadPdfFile: "Lataa PDF-tiedosto:",
    enterPdfUrl: "Syötä PDF URL:",
    pasteUrlHere: "Liitä PDF URL tähän...",
    selectPdfUrl: "Valitse PDF URL:",
    selectPdf: "-- Valitse PDF --",
    originalPattern: "Alkuperäinen Neulekuvio",
    viaCorsProxy: "CORS Proxyn Kautta",
    testPdf: "Testi PDF (Mozilla)",

    // PDF Error
    couldNotLoad: "PDF:ää ei voitu ladata suoraan. Yritä avata PDF ensin uuteen välilehteen ja palaa sitten valitsemaan alueita:",
    openInNewTab: "Avaa PDF uuteen välilehteen",
    canStillUse: "Voit silti käyttää valintatyökalua ladatussa sisällössä.",
    loadingPdf: "🔄 Ladataan PDF:ää...",
    uploadToStart: "📄 Lataa PDF-tiedosto aloittaaksesi",

    // Workspace
    dragAreasHere: "Vedä valitut alueet tänne järjestääksesi sommitelmasi",
    dragCornerToResize: "Vedä sinistä kulmakahvaa muuttaaksesi alueiden kokoa",
    availablePdfAreas: "Saatavilla Olevat PDF-alueet",
    noAreasYet: "Ei vielä valittuja alueita. Siirry \"Valitse Alueet\" -välilehteen luodaksesi PDF-alueita.",
    dropAreasHere: "Pudota PDF-alueet tähän",
    magnetSnap: "Magneettinen Tarttuminen",
    clearAll: "Tyhjennä Kaikki",
    exportImage: "Vie Kuva",

    // Crop Editor
    cropPiece: "Rajaa Alue",
    dragLinesToCrop: "Vedä punaisia viivoja määrittääksesi rajattavan alueen",
    cropAreaTooSmall: "Rajattava alue liian pieni",
    cropError: "Virhe kuvan rajaamisessa",
    saveCrop: "Tallenna Rajaus",
    cancel: "Peruuta"
  },

  pt: {
    // Header
    appTitle: "Cortar e Recompor PDF",
    tabSelectAreas: "Selecionar Áreas",
    tabCompose: "Compor Novo PDF",

    // PDF Viewer
    selectedAreas: "Áreas selecionadas",
    extracting: "🔄 Extraindo conteúdo PDF em alta resolução...",
    clickDragSelect: "✂️ Clique e arraste para selecionar áreas",
    navigateMode: "👆 Modo de navegação: role e interaja com o PDF",
    goToCompose: "🧩 Vá para Compor Novo PDF quando tiver selecionado todas as áreas necessárias",

    // PDF Controls
    selectionMode: "✂️ Seleção",
    navigateButton: "👆 Navegação",

    // Area item
    area: "Área",
    page: "Página",

    // PDF Upload
    pdfSource: "Fonte PDF:",
    localFile: "Arquivo Local",
    onlineUrl: "URL Online",
    uploadPdfFile: "Carregar arquivo PDF:",
    enterPdfUrl: "Inserir URL do PDF:",
    pasteUrlHere: "Colar URL do PDF aqui...",
    selectPdfUrl: "Selecionar URL do PDF:",
    selectPdf: "-- Selecionar PDF --",
    originalPattern: "Padrão de Tricô Original",
    viaCorsProxy: "Via Proxy CORS",
    testPdf: "PDF de Teste (Mozilla)",

    // PDF Error
    couldNotLoad: "Não foi possível carregar o PDF diretamente. Tente abrir o PDF em uma nova aba primeiro e depois volte para selecionar áreas:",
    openInNewTab: "Abrir PDF em nova aba",
    canStillUse: "Você ainda pode usar a ferramenta de seleção em qualquer conteúdo carregado.",
    loadingPdf: "🔄 Carregando PDF...",
    uploadToStart: "📄 Por favor, carregue um arquivo PDF para começar",

    // Workspace
    dragAreasHere: "Arraste as áreas selecionadas aqui para organizar sua composição",
    dragCornerToResize: "Arraste a alça de canto azul para redimensionar áreas",
    availablePdfAreas: "Áreas PDF Disponíveis",
    noAreasYet: "Nenhuma área selecionada ainda. Vá para a aba \"Selecionar Áreas\" para criar áreas PDF.",
    dropAreasHere: "Solte as áreas PDF aqui",
    magnetSnap: "Encaixe Magnético",
    clearAll: "Limpar Tudo",
    exportImage: "Exportar Imagem",

    // Crop Editor
    cropPiece: "Recortar Área",
    dragLinesToCrop: "Arraste as linhas vermelhas para definir a área de recorte",
    cropAreaTooSmall: "Área de recorte muito pequena",
    cropError: "Erro ao recortar imagem",
    saveCrop: "Salvar Recorte",
    cancel: "Cancelar"
  },

  ja: {
    // Header
    appTitle: "PDFのカットと再構成",
    tabSelectAreas: "エリアを選択",
    tabCompose: "新しいPDFを作成",

    // PDF Viewer
    selectedAreas: "選択されたエリア",
    extracting: "🔄 高解像度PDFコンテンツを抽出中...",
    clickDragSelect: "✂️ クリックしてドラッグしてエリアを選択",
    navigateMode: "👆 ナビゲーションモード：スクロールしてPDFと対話",
    goToCompose: "🧩 必要なすべてのエリアを選択したら、新しいPDFを作成に移動してください",

    // PDF Controls
    selectionMode: "✂️ 選択",
    navigateButton: "👆 ナビゲーション",

    // Area item
    area: "エリア",
    page: "ページ",

    // PDF Upload
    pdfSource: "PDFソース：",
    localFile: "ローカルファイル",
    onlineUrl: "オンラインURL",
    uploadPdfFile: "PDFファイルをアップロード：",
    enterPdfUrl: "PDF URLを入力：",
    pasteUrlHere: "ここにPDF URLを貼り付け...",
    selectPdfUrl: "PDF URLを選択：",
    selectPdf: "-- PDFを選択 --",
    originalPattern: "オリジナル編み物パターン",
    viaCorsProxy: "CORSプロキシ経由",
    testPdf: "テストPDF（Mozilla）",

    // PDF Error
    couldNotLoad: "PDFを直接読み込めませんでした。まず新しいタブでPDFを開いてから、エリアを選択するために戻ってください：",
    openInNewTab: "新しいタブでPDFを開く",
    canStillUse: "読み込まれたコンテンツで選択ツールを引き続き使用できます。",
    loadingPdf: "🔄 PDFを読み込み中...",
    uploadToStart: "📄 開始するにはPDFファイルをアップロードしてください",

    // Workspace
    dragAreasHere: "選択したエリアをここにドラッグして構成を整理します",
    dragCornerToResize: "青いコーナーハンドルをドラッグしてエリアのサイズを変更",
    availablePdfAreas: "利用可能なPDFエリア",
    noAreasYet: "まだエリアが選択されていません。「エリアを選択」タブに移動してPDFエリアを作成してください。",
    dropAreasHere: "PDFエリアをここにドロップ",
    magnetSnap: "マグネットスナップ",
    clearAll: "すべてクリア",
    exportImage: "画像をエクスポート",

    // Crop Editor
    cropPiece: "エリアをトリミング",
    dragLinesToCrop: "赤い線をドラッグしてトリミング範囲を定義します",
    cropAreaTooSmall: "トリミング範囲が小さすぎます",
    cropError: "画像のトリミングエラー",
    saveCrop: "トリミングを保存",
    cancel: "キャンセル"
  }
};

export default translations;
